import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/issue-manager");
export const getIdPath = returnPath("/issue-manager/:id");
export const getImportPath = returnPath("/issue-manager/importIssue");

export const getImportIssuePath = returnPath("/issue-manager/importIssue");